import { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "@/app/styles/index.css";
import "@/shared/i18n"; // i18n 초기화 (KR/EN/JP)

const App = lazy(() =>
  import("@/app").then((module) => ({
    default: module.App,
  }))
);

// 🔥 정리 함수를 import 아래로 이동
(function cleanupWalletProviders() {
  try {
    // 1. 모든 지갑 관련 전역 변수 제거
    delete (window as any).ethereum;
    delete (window as any).web3;
    delete (window as any).isMetaMask;
    delete (window as any).isZerion;

    // 2. 확장프로그램 이벤트 차단
    if (typeof window !== "undefined") {
      window.addEventListener("ethereum#initialized", (e) => e.stopImmediatePropagation(), true);
      window.addEventListener(
        "eip6963:announceProvider",
        (e) => e.stopImmediatePropagation(),
        true
      );
    }
  } catch (error) {
    // 무시
  }
})();

// ===== 에러 무시 설정 시작 =====
const ignoredErrors = [
  "Expected enabled to be a boolean",
  "Expected enabled to be a boolean or a callback that returns a boolean",
  "Query data cannot be undefined",
  "Network request failed",
  "ResizeObserver loop limit exceeded",
  "Non-serializable values found in the state",
  "Warning: Can't perform a React state update",
  "QueryClient",
  "useQuery",
  "useMutation",
  "Warning: React.createElement",
  "Warning: validateDOMNesting",
  // 🆕 지갑 관련 에러 추가
  "Failed to set window.ethereum",
  "MetaMask encountered an error",
  "Cannot set property ethereum",
  "Cannot redefine property",
  "isZerion",
  "isMetaMask",
  "wallet extension",
  "global Ethereum provider",
  "provider-injection",
  "inpage.js",
];

// 나머지 에러 무시 코드들...
const originalError = console.error;
console.error = (...args: any[]) => {
  const message = args.join(" ");
  const shouldIgnore = ignoredErrors.some((pattern) => message.includes(pattern));
  if (!shouldIgnore) {
    originalError.apply(console, args);
  }
};

const originalWarn = console.warn;
console.warn = (...args: any[]) => {
  const message = args.join(" ");
  const shouldIgnore = ignoredErrors.some((pattern) => message.includes(pattern));
  if (!shouldIgnore) {
    originalWarn.apply(console, args);
  }
};

window.addEventListener("unhandledrejection", (event) => {
  const message = event.reason?.message || String(event.reason);
  const shouldIgnore = ignoredErrors.some((pattern) => message.includes(pattern));
  if (shouldIgnore) {
    event.preventDefault();
  }
});

window.addEventListener("error", (event) => {
  const message = event.message || event.error?.message || "";
  const shouldIgnore = ignoredErrors.some((pattern) => message.includes(pattern));
  if (shouldIgnore) {
    event.preventDefault();
    return false;
  }
});
// ===== 에러 무시 설정 끝 =====

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Suspense
    fallback={
      <div className="flex min-h-screen items-center justify-center bg-bg-page">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-brand"></div>
      </div>
    }
  >
    <App />
  </Suspense>
);

reportWebVitals();
